module.exports = __webpack_public_path__ + "static/community_service_hype-b9bc449e203b4b306e408671570ad936.jpg";